<div class="px-4 ">
    <div *ngIf="loading"
            style="
                position: fixed;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100vh;
                background-color: rgba(255, 255, 255, 0.7); 
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 9999;"
            >
        <p-progressSpinner></p-progressSpinner>
    </div>

<p-carousel *ngIf="!loading && showCarousel" 
       [value]="items"
  [numVisible]="numVisible"
  [numScroll]="1"
  [circular]="items.length > numVisible"
  [responsiveOptions]="responsiveOptions"
  [showNavigators]="items.length > 1"
  [styleClass]="carouselClass">
    <ng-template let-item #item>
        <div class="border border-surface mt-1 mr-3 mb-3 ml-3 box-client-app" >
           <div class="mb-4">
                <div class="relative mx-auto image-gradient-wrapper"  style="width: 100%; height: 170px; overflow: hidden;">
                    <img [src]="item.imageBase64" [alt]="item.name" class="w-full" style="width: 100%; height: 100%; object-fit: cover;"/>
                    
                    <!-- El contenido flotante -->
                    <p-tag class="absolute" [ngStyle]="{ 'left.px': 15, 'top.px': 25, 'bottom.px': 25, border: '2px solid var(--border-color)', background: 'transparent', color: '#FFFFFF' }"> 
                        <div>
                            <span class="tag-client-image-big" style="position: relative;">{{ item.name }}</span>                            
                            <span class="tag-client-image-small" style="display: block; margin-top: 16px; padding-right: 30px;">{{ currentLang === 'es' ? item.description_sp : item.description_en }}</span>
                        </div>
                    </p-tag>
                </div>
            </div>
            <div style="height: 170px; overflow-y: auto;">
                <div *ngFor="let app of item.appsCards; let last = last">
                   <ng-container *ngIf="app?.url && app?.name">
                        <div (click)="handleAppClick(app)" 
                            class="box-client-space"
                            [ngStyle]="{
                            'margin-left': '10px',
                            'display': 'flex',
                            'justify-content': 'space-between',
                            'align-items': 'center',
                            'cursor': 'pointer',
                            'color': app.hasAccess ? 'inherit' : '#BABBBA',
                            'text-decoration': 'none'}">

                            <span>{{ app.alias ? app.alias : app.name }}</span>
                            <i class="pi pi-arrow-right" style="padding-right: 24px; font-size: 10px;"></i>
                        </div>

                        <hr *ngIf="!last" class="border border-surface" style="margin: 7px 14px 7px 10px !important;" />
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-template> 
</p-carousel>
</div>

<p-toast position="bottom-center" />
<p-confirmdialog #cd>
  <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
    <div class="relative flex flex-column align-items-center p-5 surface-0 border-round fixed-width-modal">
         <button
                type="button"
                (click)="onReject()"
                class="absolute top-0 right-0 m-1"
                style="border: none; background: transparent; cursor: pointer;"
                aria-label="Cerrar"
            >
                <span class="pi pi-times text-sm text-color"></span>
            </button>

      

      <span class="font-bold text-2xl block mb-2 mt-2 text-left">{{ message.header }}</span>

      <p class="mt-1 text-left message-text" style="white-space: pre-line;">{{ message.message }}</p>

      <div class="flex flex-column align-items-start gap-2 mt-4" style="width: 100%; justify-content: flex-start;">
    <p-button
        (onClick)="onAccept()"
        styleClass="save-button"
        [ngStyle]="{ 'align-self': 'flex-start' }"
    >
        <div class="flex align-items-stretch" style="width: 100%;">
            <div class="flex-grow-1 flex align-items-center justify-content-center">
                <span>{{ 'ApplicationNotAccessButton' | translate }}</span>
            </div>
            <div class="divider-container flex align-items-center">
                <span class="vertical-line"></span>
                <i class="pi pi-arrow-right arrow-icon"></i>
            </div>
        </div>
    </p-button>
</div>

    </div>
  </ng-template>
</p-confirmdialog>
<p-confirmdialog #cdOngoing key="ongoing">
    <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
    <div class="relative flex flex-column align-items-center p-5 surface-0 border-round fixed-width-modal">
       
      <span class="font-bold text-3xl block mb-2 mt-2 text-left">{{ 'ApplicationAccessPendingTitle' | translate }}</span>

      <p class="mt-1 font-bold text-left message-text">{{ 'ApplicationAccessPendingDesc' | translate }}</p>

      <div class="flex flex-column align-items-start gap-2 mt-4" style="width: 100%; justify-content: flex-start;">
      <p-button
    (onClick)="onReject()"
    styleClass="save-button"
    [ngStyle]="{ 'align-self': 'flex-start' }"
>
    <div class="flex align-items-stretch" style="width: 100%;">
        <div class="flex-grow-1 flex align-items-center justify-content-center">
            <span>{{ 'ApplicationAccessPendingButton' | translate }}</span>
        </div>
        <div class="divider-container flex align-items-center">
            <span class="vertical-line"></span>
            <i class="pi pi-arrow-right arrow-icon"></i>
        </div>
    </div>
</p-button>
      </div>

    </div>
  </ng-template>

</p-confirmdialog>

